import { useEffect, useState } from "react";
import SimpleHeader from "../../components/layout/SimpleHeader";
import { useTranslation } from "react-i18next";
import StatisticsArticleSearchForm from "../../components/statistics/articles/StatisticsArticleSearchForm";
import useAxios from "../../hooks/useAxios";
import { IGetArticleStudents, IGetArticleSummaries } from "../../models/statistics.model";
import useLoader from "../../hooks/useLoader";
import { getArticleStudents, getArticleSummaries } from "../../api/statistics.api";
import config from "../../lib/config";
import StatisticsArticlePane from "../../components/statistics/articles/StatisticsArticlePane";

export enum ArticleContents {
  Summary,
  List,
};

const StatisticsArticles = () => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetArticleSummaries>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetArticleStudents>();
  useLoader(
    isLoading || isLoading2,
    [error, error2],
  );

  const [content, setContent] = useState(ArticleContents.Summary);
  const [pageNo, setPageNo] = useState(1);
  const [params, setParams] = useState<any>({});
  const [isFirstRun, setIsFirstRun] = useState(true);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    getArticleData();
  }, [pageNo]);

  const getArticleData = (newParams?: any) => {
    const _params: any = newParams || params; 
    if (newParams) {
      setParams(newParams);
    }
    
    switch (content) {
      case ArticleContents.Summary:
        execute(getArticleSummaries(_params));
        break;
      case ArticleContents.List:
        _params.perPage = config.pageSize;
        _params.pageNo = newParams ? 1 : pageNo;
        execute2(getArticleStudents(_params));
        break;
    }
  };

  return (
    <>
    <SimpleHeader
      iconFile="icon-statistics-big.svg"
      parentMenu={t('common.menu.statistics')}
      currentMenu="Articles"
      onlyTitle={true}
    />
    <StatisticsArticleSearchForm
      content={content}
      getArticleData={getArticleData}
    />
    <div className="content scrollbar">
      <StatisticsArticlePane
        content={content}
        setContent={setContent}
        isLoading={isLoading || isLoading2}
        summaries={res?.data}
        students={res2?.data}
        studentTotal={res2?.total}
        pageNo={pageNo}
        setPageNo={setPageNo}
        params={params}
      />
    </div>
    </>
  );
};

export default StatisticsArticles;